const Resources = 
{
    table_headers: 
    [
        { 
            text: 'Name',  
            align: 'start', 
            value: 'name',
            sort_type: 'text',
        },
        {   
            text: 'Description',
            value: 'description',
            sort_type: 'text',
        },
        {   
            text: 'Permissions Given',
            value: 'total_permissions',
            type: '',
            sort_type: 'number',
        },
    ],

    breadcrumb:
    [
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Associates',
            href:   '/associates',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Permissions Templates',
            href:   '/permissions-templates',
            arrow:  "",
        },
    ],

    deletion_validation_table_headers: [
        { 
          text:     'Permissions Template',
          align:    'start',
          value:    'name',
        },
        {
            text:   '# of associates',
            value:  'associated_models_count',
        },
    ],

    helps: [
        {
            label: '¿How to add a Permission Template?', 
            instruction: `https://scribehow.com/embed/Add_a_Permission_Template__Vl4zfeksSlmIAQ8ZrCsx8Q?as=scrollable`
        },
        {
            label: '¿How to mass delete Permission Templates?', 
            instruction: `https://scribehow.com/embed/How_To_Mass_Delete_Templates__fC5_GAHLRw2qAkTUEJPJkQ?as=scrollable`
        },
    ]
}

export default Resources;